import React from 'react';
import AdminCRUD from './AdminCRUD';

const AdminDestinations = () => {
  const fields = [
    { name: 'name', label: 'Name', type: 'text', required: true, placeholder: 'e.g. Dubai' },
    { name: 'country', label: 'Country', type: 'text', required: true, placeholder: 'e.g. UAE' },
    { name: 'image', label: 'Image URL', type: 'url', required: true, placeholder: 'https://images.unsplash.com/...', fullWidth: true },
    { name: 'description', label: 'Description', type: 'textarea', required: true, placeholder: 'Discover why...', fullWidth: true },
    { name: 'highlights', label: 'Highlights', type: 'array', placeholder: 'One highlight per line', fullWidth: true },
    { name: 'promoted', label: 'Promoted', type: 'boolean', checkboxLabel: 'Show as promoted destination', default: false },
    { name: 'active', label: 'Status', type: 'boolean', checkboxLabel: 'Active', default: true },
  ];

  const columns = [
    { 
      key: 'image', 
      label: 'Image',
      render: (url) => <img src={url} alt="" className="table-thumb" />
    },
    { key: 'name', label: 'Name' },
    { key: 'country', label: 'Country' },
    { 
      key: 'promoted', 
      label: 'Promoted',
      render: (promoted) => promoted ? <i className="fa-solid fa-star" style={{color: '#f59e0b'}}></i> : '-'
    },
    { 
      key: 'active', 
      label: 'Status',
      render: (active) => <span className={`status-badge ${active ? 'active' : 'inactive'}`}>{active ? 'Active' : 'Inactive'}</span>
    },
  ];

  return (
    <AdminCRUD
      title="Destinations"
      endpoint="destinations"
      fields={fields}
      columns={columns}
      renderPreview={true}
    />
  );
};

export default AdminDestinations;
